var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { NotificationContext } from './Notification.context';
import { NotificationRegion } from './NotificationRegion';
import { defaultContextData, positions } from './Notification.constants';
let counter = 0;
const generateId = () => `__st-notification-${counter++}`;
const notificationReducer = (state, action) => {
    let nextState;
    switch (action.type) {
        case 'add': {
            const _a = action.payload.notificationProps || {}, { position = 'bottom' } = _a, notificationProps = __rest(_a, ["position"]);
            return Object.assign(Object.assign({}, state), { [position]: [
                    ...state[position],
                    { id: action.payload.id, notificationProps, status: 'entering' },
                ] });
        }
        case 'show': {
            const { id: showId } = action.payload;
            nextState = Object.assign({}, state);
            positions.forEach(position => {
                nextState[position] = nextState[position].map(item => {
                    return item.id === showId ? Object.assign(Object.assign({}, item), { status: 'entered' }) : item;
                });
            });
            return nextState;
        }
        case 'hide': {
            const { id: hideId } = action.payload;
            nextState = Object.assign({}, state);
            positions.forEach(position => {
                nextState[position] = nextState[position].map(item => item.id === hideId ? Object.assign(Object.assign({}, item), { status: 'exiting' }) : item);
            });
            return nextState;
        }
        case 'remove': {
            const { id: removeId } = action.payload;
            nextState = Object.assign({}, state);
            positions.forEach(position => {
                nextState[position] = nextState[position].filter(item => item.id !== removeId);
            });
            return nextState;
        }
    }
};
export const NotificationProvider = (props) => {
    const { children, options } = props;
    const [data, dispatch] = React.useReducer(notificationReducer, defaultContextData.queues);
    const add = React.useCallback(props => {
        const id = generateId();
        dispatch({ type: 'add', payload: { notificationProps: props, id } });
        return id;
    }, []);
    const show = React.useCallback((id) => {
        dispatch({ type: 'show', payload: { id } });
    }, []);
    const hide = React.useCallback((id) => {
        dispatch({ type: 'hide', payload: { id } });
    }, []);
    const remove = React.useCallback((id) => {
        dispatch({ type: 'remove', payload: { id } });
    }, []);
    const value = React.useMemo(() => {
        return {
            queues: data,
            add,
            show,
            hide,
            remove,
            inspecting: false,
            options,
        };
    }, [data, show, hide, add, remove, options]);
    return (_jsxs(NotificationContext.Provider, { value: value, children: [children, positions.map(position => (_jsx(NotificationRegion, { position: position }, position)))] }));
};
